import Vue from "vue";
import Router from "vue-router";
import { store } from "./store";
import url from "./service/base-url";
import checkPermission from "./service/checkPermission";
import { storage } from "./service/storage";

Vue.use(Router);

let router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      component: () => import("./views/Home.vue"),
      children: [
        {
          path: "",
          name: "home",
          component: () => import("./views/HomeIndex.vue"),
          meta: { title: "渔联交易通" },
        },
        {
          path: "/check/index",
          meta: {
            title: "检测管理",
          },
          name: "check",
          component: () => import("./views/check/Index.vue"),
        },
        {
          path: "/check/detail",
          meta: {
            title: "检测详情",
          },
          name: "checkDetail",
          component: () => import("./views/check/Detail.vue"),
        },
        {
          path: "/check/edit",
          meta: {
            title: "立即检测",
          },
          name: "checkEdit",
          component: () => import("./views/check/Edit.vue"),
        },
        {
          path: "/salesSummaryList",
          name: "salesSummaryList",
          component: () => import("./views/SalesSummaryList.vue"),
          meta: { title: "销售报表" },
        },
        {
          path: "/purchaseSummaryList",
          name: "purchaseSummaryList",
          component: () => import("./views/PurchaseSummaryList.vue"),
          meta: { title: "采购报表" },
        },
        {
          path: "setting/vehicleSetting",
          component: () =>
            import(
              "./components/setting/vehicleSetting/VehicleSettingManagement.vue"
            ),
          meta: {
            menuId: "1808071001030000130",
          },
          children: [
            {
              path: "/",
              name: "vehicleSetting",
              component: () =>
                import(
                  "@/components/setting/vehicleSetting/VehicleSetting.vue"
                ),
              meta: { title: "车辆管理" },
            },
            {
              path: "/vehicleSettingEdit",
              name: "vehicleSettingEdit",
              component: () =>
                import(
                  "@/components/setting/vehicleSetting/VehicleSettingEdit.vue"
                ),
              meta: { title: "车辆管理" },
            },
          ],
        },
        //平仓管理
        {
          path: "setting/pingcang",
          component: () =>
            import("./components/setting/pingcang/PingcangManagement.vue"),

          children: [
            {
              path: "/",
              name: "pingcang",
              component: () =>
                import("@/components/setting/pingcang/Pingcang.vue"),
              meta: { title: "平仓管理" },
            },
          ],
        },
        //设备管理
        {
          path: "setting/equipment",
          component: () =>
            import("./components/setting/equipment/EquipManagement.vue"),

          children: [
            {
              path: "/",
              name: "equipmentIndex",
              component: () =>
                import("@/components/setting/equipment/Index.vue"),
              meta: { title: "设备管理" },
            },
          ],
        },
        {
          path: "setting/batchSetting",
          component: () =>
            import(
              "./components/setting/batchSetting/BatchSettingManagement.vue"
            ),
          meta: {
            menuId: "1808071001030000130",
          },
          children: [
            {
              path: "/",
              name: "batchSetting",
              component: () =>
                import("@/components/setting/batchSetting/BatchSetting.vue"),
              meta: { title: "批次设置" },
            },
            {
              path: "batchSettingEdit",
              name: "batchSettingEdit",
              component: () =>
                import(
                  "@/components/setting/batchSetting/BatchSettingEdit.vue"
                ),
              // meta: { title: "批次设置" }
            },
          ],
        },
        {
          path: "setting/productSetting",
          component: () =>
            import("./components/setting/productSetting/ProductManagement.vue"),
          children: [
            {
              path: "/",
              name: "productList",
              component: () =>
                import("@/components/setting/productSetting/ProductList.vue"),
              meta: { title: "产品设置" },
            },
            {
              path: "addProduct",
              name: "addProduct",
              component: () =>
                import("@/components/setting/productSetting/AddProduct.vue"),
              // meta: { title: "" }
            },
          ],
        },

        // 采购入库
        {
          path: "purchase/purchaseList",
          component: () =>
            import("@/components/purchase/PurchaseManagement.vue"),
          meta: {
            menuId: "1808071002370000130",
          },
          children: [
            {
              path: "/",
              name: "purchaseList",
              component: () => import("@/components/purchase/PurchaseList.vue"),
              meta: { title: "采购单列表" },
            },
            {
              path: "purchaseAdd",
              name: "purchaseAdd",
              component: () => import("@/components/purchase/AddPurchase.vue"),
              meta: { title: "新增采购入库单" },
            },
            {
              path: "purchaseDetail",
              name: "purchaseDetail",
              component: () =>
                import("@/components/purchase/PurchaseDetail.vue"),
              meta: { title: "采购明细表" },
            },
            {
              path: "purchaseTotalReport",
              name: "purchaseTotalReport",
              component: () =>
                import("@/components/purchase/PurchaseTotalReport.vue"),
              meta: { title: "采购汇总表" },
            },
          ],
        },
        // 销售出库
        {
          path: "sales/salesList",
          component: () => import("@/components/sales/SalesManagement.vue"),
          meta: {
            menuId: "1808071002370000130",
          },
          children: [
            {
              path: "/",
              name: "salesList",
              component: () => import("@/components/sales/SalesList.vue"),
              meta: { title: "销售单列表" },
            },
            {
              path: "salesAdd",
              name: "salesAdd",
              component: () => import("@/components/sales/AddSales.vue"),
              meta: { title: "新增销售出库单" },
            },
            {
              path: "salesDetail",
              name: "salesDetail",
              component: () => import("@/components/sales/SalesDetail.vue"),
              meta: { title: "销售明细表" },
            },
            {
              path: "salesTotalReport",
              name: "salesTotalReport",
              component: () =>
                import("@/components/sales/SalesTotalReport.vue"),
              meta: { title: "销售汇总表" },
            },
          ],
        },
        // 对装管理
        {
          path: "duiZhuang/duiZList",
          component: () => import("@/components/duiZhuang/DuiZManagement.vue"),

          children: [
            {
              path: "/",
              name: "duiZList",
              component: () => import("@/components/duiZhuang/DuiZList.vue"),
              meta: { title: "对装单列表" },
            },
            {
              path: "addDuiZ",
              name: "addDuiZ",
              component: () => import("@/components/duiZhuang/AddDuiZ.vue"),
              meta: { title: "新增对装入库单" },
            },
            {
              path: "duiZDetail",
              name: "duiZDetail",
              component: () => import("@/components/duiZhuang/DuiZDetail.vue"),
              meta: { title: "对装明细表" },
            },
            {
              path: "duiZTotalReport",
              name: "duiZTotalReport",
              component: () =>
                import("@/components/duiZhuang/DuiZTotalReport.vue"),
              meta: { title: "对装汇总表" },
            },
          ],
        },
        //挂单/作废单
        // 销售出库
        {
          path: "noSettleBalance/noSettleBalance",
          component: () =>
            import("@/components/noSettleBalance/NoSettleBalanceManage.vue"),

          children: [
            {
              path: "/",
              name: "noSettleBalance",
              component: () =>
                import("@/components/noSettleBalance/NoSettleBalance.vue"),
              meta: { title: "挂单/作废单" },
            },
          ],
        },
        // 入境登记单管理
        {
          path: "edCardTable/edCardTable",
          component: () =>
            import("@/components/edCardTable/EdCardManagement.vue"),

          children: [
            {
              path: "/",
              name: "edCardTable",
              component: () =>
                import("@/components/edCardTable/EdCardTable.vue"),
              meta: { title: "入境登记表" },
            },
            {
              path: "addEdCardTable",
              name: "addEdCardTable",
              component: () =>
                import("@/components/edCardTable/AddEdCardTable.vue"),
              meta: { title: "新增入境登记单" },
            },
          ],
        },
        //报表分析
        {
          path: "reportAnalyze/stockReport",
          component: () =>
            import(
              "@/components/reportAnalyze/stockReport/StockTotalManage.vue"
            ),
          meta: {
            menuId: "1808071002370000130",
          },
          children: [
            {
              path: "/",
              name: "stockDetailReport",
              component: () =>
                import(
                  "@/components/reportAnalyze/stockReport/StockDetailReport.vue"
                ),
              meta: { title: "库存明细报表" },
            },
            {
              path: "stockTotalReport",
              name: "stockTotalReport",
              component: () =>
                import(
                  "@/components/reportAnalyze/stockReport/StockTotalReport.vue"
                ),
              meta: { title: "库存汇总表" },
            },
          ],
        },
        // 批次报表
        {
          path: "reportAnalyze/batchReport",
          name: "batchReport",
          component: () =>
            import("@/components/reportAnalyze/batchReport/batchReport.vue"),
          meta: { title: "批次报表" },
        },
        // 亏称明细报表
        {
          path: "reportAnalyze/kuiChengReport",
          name: "kuiChengReport",
          component: () =>
            import(
              "@/components/reportAnalyze/kuiChengReport/KuiChengReport.vue"
            ),
          meta: { title: "亏称明细报表" },
        },
        //人员管理
        {
          path: "setting/personManagement",
          component: () =>
            import(
              "@/components/setting/personalAuthorityManagement/PersonManagement.vue"
            ),
          children: [
            {
              path: "/",
              name: "PersonManagement",
              component: () =>
                import(
                  "@/components/setting/personalAuthorityManagement/PersonManagement.vue"
                ),
              meta: { title: "人员管理" },
            },
          ],
        },
        //公司设置
        {
          path: "setting/companySetting",
          component: () =>
            import(
              "@/components/setting/companySetting/CompanySettingManage.vue"
            ),
          children: [
            {
              path: "/",
              name: "companySetting",
              component: () =>
                import(
                  "@/components/setting/companySetting/CompanySetting.vue"
                ),
              meta: { title: "公司设置" },
            },
          ],
        },
        // {
        //   path: "setting/paymentSetting",
        //   component: () =>
        //     import("@/components/setting/paymentSetting/PaymentSettingManage.vue"),
        //   children: [
        //     {
        //       path: "/",
        //       name: "paymentSetting",
        //       component: () =>
        //         import("@/components/setting/paymentSetting/PaymentSetting.vue"),
        //       meta: { title: "收款设置" }
        //     }
        //   ]
        // },
        //客户列表
        {
          path: "setting/clientSetting",
          component: () =>
            import("@/components/setting/clientSetting/ClientManagement.vue"),
          children: [
            {
              path: "/",
              name: "client",
              component: () =>
                import("@/components/setting/clientSetting/Client.vue"),
              meta: { title: "客户列表" },
            },
            {
              path: "addClient",
              name: "addClient",
              component: () =>
                import("@/components/setting/clientSetting/AddClient.vue"),
              // meta: { title: "添加客户" }
            },
          ],
        },
        //供应商列表
        {
          path: "setting/supplierSetting",
          component: () =>
            import(
              "@/components/setting/supplierSetting/SupplierManagement.vue"
            ),
          children: [
            {
              path: "/",
              name: "supplier",
              component: () =>
                import("@/components/setting/supplierSetting/Supplier.vue"),
              meta: { title: "供应商列表" },
            },
            {
              path: "addSupplier",
              name: "addSupplier",
              component: () =>
                import("@/components/setting/supplierSetting/AddSupplier.vue"),
              // meta: { title: "添加供应商" }
            },
          ],
        },
        //产品规格
        {
          path: "setting/productSpec",
          component: () =>
            import("@/components/setting/productSpec/ProductSpecManage.vue"),
          meta: {
            menuId: "1904191539260000166",
          },
          children: [
            {
              path: "",
              name: "productSpec",
              component: () =>
                import("@/components/setting/productSpec/ProductSpec.vue"),
              meta: { title: "产品规格" },
            },
          ],
        },
        //仓库设置
        {
          path: "warehouse/warehouseList",
          component: () => import("@/components/warehouse/WarehouseManage.vue"),
          meta: {
            menuId: "1904191539260000166",
          },
          children: [
            {
              path: "",
              name: "warehouseList",
              component: () =>
                import("@/components/warehouse/WarehouseSetting.vue"),
              meta: { title: "仓库设置" },
            },
          ],
        },
        //客户欠款
        {
          path: "/customerArrears",
          component: () =>
            import("@/components/customerArrears/CustomerArrManage.vue"),
          meta: {
            menuId: "1904191539260000166",
          },
          children: [
            {
              path: "",
              name: "customerArrearsTotal",
              component: () =>
                import("@/components/customerArrears/CustomerArrearsTotal.vue"),
              meta: { title: "客户欠款汇总" },
            },
            {
              path: "customerArrearsDetail",
              name: "customerArrearsDetail",
              component: () =>
                import(
                  "@/components/customerArrears/CustomerArrearsDetail.vue"
                ),
              meta: { title: "客户欠款明细" },
            },
          ],
        },
        //应付账款
        {
          path: "/payableAccount",
          component: () =>
            import("@/components/payableAccount/PayableAccountManage.vue"),
          meta: {
            menuId: "1904191539260000166",
          },
          children: [
            {
              path: "",
              name: "payableAccountTotal",
              component: () =>
                import("@/components/payableAccount/PayableAccountTotal.vue"),
              meta: { title: "应付账款汇总" },
            },
            {
              path: "payableAccountDetail",
              name: "payableAccountDetail",
              component: () =>
                import("@/components/payableAccount/PayableAccountDetail.vue"),
              meta: { title: "应付账款明细" },
            },
          ],
        },
        // 收款单
        {
          path: "/receipt",
          component: () => import("@/components/receipt/ReceiptManageMent.vue"),
          meta: {
            menuId: "1904191539260000166",
          },
          children: [
            {
              path: "",
              name: "receiptList",
              component: () => import("@/components/receipt/ReceiptList.vue"),
              meta: { title: "收款单列表" },
            },
            {
              path: "addReceipt",
              name: "addReceipt",
              component: () => import("@/components/receipt/AddReceipt.vue"),
              meta: { title: "新增收款单" },
            },
            {
              path: "receiptTotal",
              name: "receiptTotal",
              component: () => import("@/components/receipt/ReceiptTotal.vue"),
              meta: { title: "收款汇总表" },
            },
          ],
        },
        // 付款单
        {
          path: "/payment",
          component: () => import("@/components/payment/paymentManageMent.vue"),
          meta: {
            menuId: "1904191539260000166",
          },
          children: [
            {
              path: "",
              name: "paymentList",
              component: () => import("@/components/payment/PaymentList.vue"),
              meta: { title: "付款单列表" },
            },
            {
              path: "addPayment",
              name: "addPayment",
              component: () => import("@/components/payment/AddPayment.vue"),
              meta: { title: "新增付款单" },
            },
            {
              path: "paymentTotal",
              name: "paymentTotal",
              component: () => import("@/components/payment/PaymentTotal.vue"),
              meta: { title: "付款汇总表" },
            },
          ],
        },
        //仓库调拨单
        {
          path: "warehouseTransfer/warehouseTList",
          component: () =>
            import("@/components/warehouseTransfer/WarehouseTManage.vue"),
          meta: {
            menuId: "1904191539260000166",
          },
          children: [
            {
              path: "",
              name: "warehouseT",
              component: () =>
                import("@/components/warehouseTransfer/warehouseT.vue"),
              meta: { title: "仓库调拨单" },
            },
            {
              path: "addWarehouseT",
              name: "addWarehouseT",
              component: () =>
                import("@/components/warehouseTransfer/AddWarehouseT.vue"),
              meta: { title: "仓库调拨单" },
            },
          ],
        },
        //调拨入库单
        {
          path: "inWareHouse/inWarehouse",
          component: () =>
            import("@/components/inWareHouse/InWarehouseManage.vue"),
          meta: {
            menuId: "1904191539260000166",
          },
          children: [
            {
              path: "",
              name: "inWarehouse",
              component: () =>
                import("@/components/inWareHouse/InWarehouse.vue"),
              meta: { title: "调拨入库单" },
            },
            {
              path: "addInWarehouse",
              name: "addInWarehouse",
              component: () =>
                import("@/components/inWareHouse/AddInWarehouse.vue"),
              meta: { title: "调拨入库单" },
            },
          ],
        },
        //调拨出库单
        {
          path: "outWareHouse/outWarehouse",
          component: () =>
            import("@/components/outWareHouse/OutWarehouseManage.vue"),
          meta: {
            menuId: "1904191539260000166",
          },
          children: [
            {
              path: "",
              name: "outWarehouse",
              component: () =>
                import("@/components/outWareHouse/OutWarehouse.vue"),
              meta: { title: "调拨出库单" },
            },
            {
              path: "addOutWarehouse",
              name: "addOutWarehouse",
              component: () =>
                import("@/components/outWareHouse/AddOutWarehouse.vue"),
              meta: { title: "调拨出库单" },
            },
          ],
        },
        // 仓库调拨明细表
        {
          path: "allocationDetails/allocationDetails",
          component: () =>
            import(
              "@/components/allocationDetails/AllocationDetailsManage.vue"
            ),
          meta: {
            menuId: "1904191539260000166",
          },
          children: [
            {
              path: "",
              name: "allocationDetails",
              component: () =>
                import("@/components/allocationDetails/AllocationDetails.vue"),
              meta: { title: "仓库调拨明细表" },
            },
          ],
        },
        // 仓库调拨汇总表
        {
          path: "transferSummary/transferSummary",
          component: () =>
            import("@/components/transferSummary/transferSummaryManage.vue"),
          meta: {
            menuId: "1904191539260000166",
          },
          children: [
            {
              path: "",
              name: "transferSummary",
              component: () =>
                import("@/components/transferSummary/transferSummary.vue"),
              meta: { title: "仓库调拨汇总表" },
            },
          ],
        },
        //损益管理
        {
          path: "gainLoss/gainLossList",
          component: () => import("@/components/gainLoss/GainLossManage.vue"),
          meta: {
            menuId: "1904191539260000166",
          },
          children: [
            {
              path: "",
              name: "gainLoss",
              component: () => import("@/components/gainLoss/GainLoss.vue"),
              meta: { title: "损溢单" },
            },
            {
              path: "addGainLoss",
              name: "addGainLoss",
              component: () => import("@/components/gainLoss/AddGainLoss.vue"),
              meta: { title: "损溢单" },
            },
            {
              path: "gainLossDetail",
              name: "gainLossDetail",
              component: () =>
                import("@/components/gainLoss/GainLossDetail.vue"),
              meta: { title: "损溢明细表" },
            },
            {
              path: "gainLossTotalReport",
              name: "gainLossTotalReport",
              component: () =>
                import("@/components/gainLoss/GainLossTotalReport.vue"),
              meta: { title: "损溢汇总表" },
            },
          ],
        },

        //成本管理
        {
          path: "expense/costOriginValue",
          component: () =>
            import(
              "@/components/expense/costOriginValue/CostOriginValueManage.vue"
            ),

          children: [
            {
              path: "/",
              name: "costOriginValue",
              component: () =>
                import(
                  "@/components/expense/costOriginValue/CostOriginValue.vue"
                ),
              meta: { title: "资产原值" },
            },
            {
              path: "addCostOriginValue",
              name: "addCostOriginValue",
              component: () =>
                import(
                  "@/components/expense/costOriginValue/AddCostOriginValue.vue"
                ),
              meta: { title: "添加资产原值" },
            },
          ],
        },
        {
          path: "expense/assetsCalculation",
          component: () => import("@/components/expense/AssetsCalculation.vue"),
          meta: {
            title: "资产计提",
          },
        },
        {
          path: "expense/expenseRecord",
          component: () =>
            import("@/components/expense/expenseRecord/ExpenseManagement.vue"),

          children: [
            {
              path: "/",
              name: "expenseRecord",
              component: () =>
                import("@/components/expense/expenseRecord/ExpenseRecord.vue"),
              meta: { title: "费用记录" },
            },
            {
              path: "addExpenseRecord",
              name: "addExpenseRecord",
              component: () =>
                import(
                  "@/components/expense/expenseRecord/AddExpenseRecord.vue"
                ),
            },
          ],
        },
        {
          path: "expense/costSummaryTable",
          component: () => import("@/components/expense/CostSummaryTable.vue"),
          meta: {
            title: "费用分摊汇总表",
          },
        },
        {
          path: "expense/expenseSetting",
          component: () =>
            import(
              "@/components/expense/expenseSetting/ExpenseSettingManagement.vue"
            ),

          children: [
            {
              path: "/",
              name: "expenseSetting",
              component: () =>
                import(
                  "@/components/expense/expenseSetting/ExpenseSetting.vue"
                ),
              meta: { title: "费用类型设置" },
            },
            {
              path: "detail",
              name: "ExpenseDetail",
              component: () =>
                import("@/components/expense/expenseSetting/ExpenseDetail.vue"),
              meta: { title: "费用设置" },
            },
          ],
        },

        //卡片管理
        {
          path: "query/card/index",
          meta: {
            title: "卡片管理",
          },
          name: "queryCardIndex",
          component: () => import("@/components/query/card/Index.vue"),
        },
        //卡片详情
        {
          path: "query/card/detail",
          meta: {
            title: "卡片详情",
          },
          name: "queryCardDetail",
          component: () => import("@/components/query/card/Detail.vue"),
        },
        //卡片批量注册
        {
          path: "batchCard",
          meta: {
            title: "卡片批量注册",
          },
          name: "batchCard",
          component: () => import("@/components/batchOpenCard/Index.vue"),
        },
        //刷卡查询
        {
          path: "query/credit/index",
          meta: {
            title: "刷卡查询",
          },
          name: "creditIndex",
          component: () => import("@/components/query/credit/Index.vue"),
        },
        //卡片充值
        {
          path: "cardRecharge",
          meta: {
            title: "卡片充值",
          },
          name: "cardRecharge",
          component: () => import("@/components/cardRecharge/Index.vue"),
        },
        {
          path: "opencard",
          meta: {
            title: "开卡",
          },
          name: "opencard",
          component: () => import("@/components/opencard/Index.vue"),
        },
        //称重单明细
        {
          path: "weighing/weighingDetail",
          component: () => import("@/components/weighing/WeighingManage.vue"),
          meta: {
            menuId: "1904191539260000999",
          },
          children: [
            {
              path: "",
              name: "weighingDetail",
              component: () =>
                import("@/components/weighing/WeighingDetail.vue"),
              meta: { title: "称重单明细" },
            },
            {
              path: "cancelWeighingDetail",
              name: "cancelWeighingDetail",
              component: () =>
                import("@/components/weighing/CancelWeighingDetail.vue"),
              meta: { title: "称重单明细" },
            },
            {
              path: "duiZOrderDetail",
              name: "duiZOrderDetail",
              component: () =>
                import("@/components/weighing/DuiZOrderDetail.vue"),
              meta: { title: "对装单明细" },
            },
          ],
        },
        // 渔交易
        {
          path: "handselSetting",
          meta: {
            title: "定金设置",
          },
          name: "handselSetting",
          component: () => import("@/components/yujiaoyi/HandselSetting.vue"),
        },
        {
          path: "orderSetting",
          meta: {
            title: "订单管理",
          },
          name: "orderSetting",
          component: () => import("@/components/yujiaoyi/OrderSetting.vue"),
        },
        {
          path: "orderDetail",
          meta: {
            title: "订单详情",
          },
          name: "orderDetail",
          component: () => import("@/components/yujiaoyi/OrderDetail.vue"),
        },
        {
          path: "proSetting",
          meta: {
            title: "商品管理",
          },
          name: "proSetting",
          component: () => import("@/components/yujiaoyi/ProductSetting.vue"),
        },
        {
          path: "403",
          component: () => import("./views/403.vue"),
          meta: { title: "无权限" },
        },
        {
          path: "noPermissions",
          component: () => import("./views/NoPermissions.vue"),
          meta: { title: "未分配权限" },
        },
      ],
    },
    {
      path: "/login",
      name: "login",
      component: () => import("./components/login/Login.vue"),
      meta: { title: "登录" },
    },
    {
      path: "/unauthorized",
      name: "unauthorized",
      component: () => import("./views/unauthorized.vue"),
      meta: { title: "未认证" }
    },
    {
      path: "/logincallback",
      name: "logincallback",
      component: () => import("./components/login/LoginCallback.vue"),
      meta: { title: "跳转中" },
    },
    {
      path: "/createFishery",
      name: "CreateFishery",
      component: () => import("./components/login/CreateFishery.vue"),
      meta: { title: "创建单位" },
    },
    {
      path: "/changeFishery",
      name: "changeFishery",
      component: () => import("./components/login/ChangeFishery.vue"),
      meta: { title: "进入单位" },
    },
    {
      path: "/bigdata",
      meta: {
        title: "企业实时运行平台",
      },
      name: "bigdata",
      component: () => import("./bigdata/index/Index.vue"),
    },
    {
      path: "/nationalData",
      meta: {
        title: "企业实时运行平台",
      },
      name: "nationalData",
      component: () => import("./nationalData/Index.vue"),
    },
    {
      path: "/specRateDetail",
      meta: {
        title: "交易额柱状图",
      },
      name: "specRateDetail",
      component: () => import("./components/bigdata/SpecRateDetail.vue"),
    },
    {
      path: "/merchantRateDetail",
      meta: {
        title: "仓库损益情况",
      },
      name: "merchantRateDetail",
      component: () => import("./components/bigdata/MerchantRateDetail.vue"),
    },
    {
      path: "/purchaseDealDetail",
      meta: {
        title: "产品采购支出",
      },
      name: "purchaseDealDetail",
      component: () => import("./components/bigdata/PurchaseDealDetail.vue"),
    },
    {
      path: "/volumeHistogramDetail",
      meta: {
        title: "交易额柱状图",
      },
      name: "volumeHistogramDetail",
      component: () => import("./components/bigdata/VolumeHistogramDetail.vue"),
    },
    {
      path: "/trendChartUnitPrice",
      meta: {
        title: "活跃买家数变化曲线",
      },
      name: "trendChartUnitPrice",
      component: () => import("./components/bigdata/TrendChartUnitPrice.vue"),
    },
    {
      path: "/trendVolumeTrendLine",
      meta: {
        title: "交易量走势图",
      },
      name: "trendVolumeTrendLine",
      component: () => import("./components/bigdata/TrendVolumeTrendLine.vue"),
    },
    {
      path: "/marketDistribution",
      meta: {
        title: "交易市场分布",
      },
      name: "marketDistribution",
      component: () => import("./components/bigdata/MarketDistribution.vue"),
    },
  ],
  // 固定路由跳转高度
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});
/* eslint-disable*/
router.beforeEach(async (to, from, next) => {
  let pathArr = to.path.split('/')
  let fromArr = from.path.split('/')
  console.log(pathArr[1], fromArr[1])
  console.log(localStorage.getItem("pageNumber"))
  if(pathArr[1] != fromArr[1]) {
    localStorage.setItem("pageNumber", 1);
  } else if(from.path == "/") {
    localStorage.setItem("pageNumber", Number(localStorage.getItem("pageNumber")));
  }
  if (to.query.appid) {
    store.commit('setInQlw');
  }

  if (to.fullPath.indexOf('login') == -1) {
    storage.set('currentUrl', window.location.href);
  }

  if (to.name == 'smartDevice') {
    var win = window.open(url.smartDevice, '_blank');
    win.focus();
    return;
  }
  if (to.name == 'enterpriseBigData') {
    var win = window.open(url.enterpriseBigData, '_blank');
    win.focus();
    return;
  }
  if (to.name == 'qualityTracingList' && from.name!= null && from.path.indexOf('backEnd')==-1) {
    window.open(url.pcQuantityUrl);
    // win.focus();
    return;
  }
  
  if (!store.state.loginUser && to.fullPath.indexOf('/login') == -1) {
    await store.dispatch('getLoginUser');
  }
  if (!store.state.authorizedInfo && to.fullPath.indexOf('/login') == -1) {
    await store.dispatch('getAuthorizedInfo');
  }
  next();
});

router.afterEach((to, from) => {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title;
  }
});

export default router;
